import { render } from "./CompanyView.vue?vue&type=template&id=1cfc7fe2&scoped=true"
const script = {}

import "./CompanyView.vue?vue&type=style&index=0&id=1cfc7fe2&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfc7fe2"]])

export default __exports__